import { useState } from "react";
import { faPlus, faMinus } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { ActionIconProps } from "@mantine/core";
import { LeafletControlWrapperProps } from "components/LeafletMap/Utils/LeafletControlWrapper";
import { useMap, useMapEvents } from "react-leaflet";
import { ControlActionIcon } from "../ControlActionIcon";
import { MergedControl } from "../MergedControl/MergedControl";
import { MapID } from "config/enums/mapIDs";

const ZoomActionIcon = ({
  children,
  ...rest
}: ActionIconProps & React.ComponentPropsWithoutRef<"button">) => (
  <ControlActionIcon {...rest}>{children}</ControlActionIcon>
);

type Props = {
  mapId: MapID;
  position: LeafletControlWrapperProps["position"];
};

const maxZooms = new Map([
  [MapID.openStreetMap, 17],
  [MapID.openTopoMap, 17],
  [MapID.cyclOSM, 17],
  [MapID.satellite, 19],
]);

export const CustomZoomControl = ({ mapId, position }: Props) => {
  const map = useMap();
  const [currentZoom, setCurrentZoom] = useState(map.getZoom());
  useMapEvents({
    zoomend: () => setCurrentZoom(map.getZoom()),
  });

  const mapIdMaxZoom = maxZooms.get(mapId);
  const isMaxZoom = currentZoom >= map.getMaxZoom();
  const isMinZoom = currentZoom <= map.getMinZoom();

  return (
    <MergedControl position={position}>
      <ZoomActionIcon
        onClick={() => map.zoomIn()}
        disabled={(mapIdMaxZoom && currentZoom > mapIdMaxZoom) || isMaxZoom}
      >
        <FontAwesomeIcon icon={faPlus} />
      </ZoomActionIcon>
      <ZoomActionIcon onClick={() => map.zoomOut()} disabled={isMinZoom}>
        <FontAwesomeIcon icon={faMinus} />
      </ZoomActionIcon>
    </MergedControl>
  );
};
